import { RadioButton } from "@newsela/angelou";
import PropTypes from "prop-types";

import { assigneeTypeTitleCss } from "../AssigneeSelectorModal/AssigneeSelectorModal.style";

const propTypes = {
  setAssigneeSelectionTypeOptions: PropTypes.func,
  assigneeSelectionTypeOptions: PropTypes.string,
};

const AssigneeTypeSelection = ({
  setAssigneeSelectionTypeOptions,
  assigneeSelectionTypeOptions,
}) => {
  return (
    <div>
      <h3 css={assigneeTypeTitleCss}>Choose 1 option:</h3>
      <RadioButton
        value="enireClasses"
        label="Entire classes"
        name="assignee option"
        __cssFor={{ root: { marginBottom: "8px" } }}
        onClick={() => setAssigneeSelectionTypeOptions("classrooms")}
        checked={assigneeSelectionTypeOptions === "classrooms"}
        withContainer
      />
      <RadioButton
        value="individualOrSmallGroups"
        label="Individuals or small groups"
        name="assignee option"
        onClick={() => setAssigneeSelectionTypeOptions("students")}
        checked={assigneeSelectionTypeOptions === "students"}
        withContainer
      />
    </div>
  );
};

AssigneeTypeSelection.propTypes = propTypes;
export default AssigneeTypeSelection;
